/**
 * Created by Christof Sander on 17.01.2017.
 */

var store = require('../../../lib/store');
const utils = require('../../../lib/utils');

module.exports = {
	config: {
		draggable: {
			durations: {
				moveElement: .3
			}
		}
	},

	model: {
		tagPickerButton: false
	},

	events: {
		openFileManagement: {
			type: 'click',
			selector: 'button.base_form_fields_file-button',
			action: function(event){
				event.preventDefault();
				event.stopImmediatePropagation();

				event.data.component.openFileManagement();
			}
		},

		singleFileAction: {
			type: 'click',
			selector: '.base_form_media_file_file button',
			action: function(event){
				var mediaID = $(event.target).closest('.base_form_media_file_file').data('mediaId');
				if(mediaID){
					event.preventDefault();
					event.stopImmediatePropagation();
					utils.performButtonAction(event, undefined, { mediaID: mediaID });
				}
			}
		},

		allFilesAction: {
			type: 'click',
			selector: 'button.base_form_elements_buttons_default',
			action: function(event){
				event.preventDefault();
				event.stopImmediatePropagation();
				utils.performButtonAction(event, undefined, { operateOnAllFiles: true });
			}
		}
	},

	methods: {

		showEdit: function(baseActionKey, buttonContext, buttonMode, actionBossComponent, additionalData){
			// TODO: SHOW EDIT FUNCTIONALITY?!
			// var file = utils.media.getMediaDataByID(this.model.dataJSON, additionalData.mediaID);
			// if(file){
			// 	return this.performAction(
			// 		this.prepareAction('fileDetails', additionalData.mediaID, {
			// 			fileDetails: file
			// 		})
			// 	);
			// }

			return utils.promise.reject();
		},

		delete: function(baseActionKey, buttonContext, buttonMode, actionBossComponent, additionalData){
			var file = utils.media.getMediaDataByID(this.model.dataJSON, additionalData.mediaID);
			if(file && file.index !== undefined){
				if(this.model.dataJSON[file.index].delete){
					this.model.dataJSON[file.index].delete = false;
				}
				else {
					this.model.dataJSON[file.index].delete = true;
				}

				// check if config prevents some user decisions (like maxNrOfElements limit reached, ...)
				var managementConfig = {};
				if(this.model.config) managementConfig = this.model.config.managementConfig;
				this.reworkFileList(managementConfig, file.index);
			}
			else if(additionalData.operateOnAllFiles) {
				var m;
				for(m in this.model.dataJSON){
					this.model.dataJSON[m].delete = true;
				}

				// check if config prevents some user decisions (like maxNrOfElements limit reached, ...)
				var managementConfig = {};
				if(this.model.config) managementConfig = this.model.config.managementConfig;
				this.reworkFileList(managementConfig);
			}
		},

		download: function(baseActionKey, buttonContext, buttonMode, actionBossComponent, additionalData){
			var mediaID = (additionalData || {}).mediaID;

			if(mediaID){
				for(var f in this.model.dataJSON || {}){
					var file = this.model.dataJSON[f] || {}
					if(file.mediaID === mediaID){
						if(file.url){
							window.open(file.url, '_blank').focus();
						}
						break;
					}
				}
			}
		},

		filter: function(baseActionKey, buttonContext, buttonMode, actionBossComponent, additionalData){
			this.openFileManagement(true);
		},

		closeFullScreen: function(baseActionKey, buttonContext, buttonMode, actionBossComponent, additionalData){
			this.fullScreen(baseActionKey, buttonContext, buttonMode, actionBossComponent, additionalData);
		},

		fullScreen: function(baseActionKey, buttonContext, buttonMode, actionBossComponent, additionalData){
			if(this.model.fullScreen){
				this.model.fullScreen = false;
				this.$.closest('.base_tabStrip_tabContent, .base_modal_modal > .window > .body').find('.fullScreenHidden').removeClass('fullScreenHidden');
				this.$.closest('.base_tabStrip_tabContent, .base_modal_modal > .window > .body').find('.fullScreen').removeClass('fullScreen');
			} else {
				this.model.fullScreen = true;
				this.$.find('*').addClass('fullScreen');
				this.$.parentsUntil('.base_tabStrip_tabContent, .base_modal_modal > .window > .body').addClass('fullScreen');
				this.$.closest('.base_tabStrip_tabContent, .base_modal_modal > .window > .body').find('*:not(.fullScreen)').addClass('fullScreenHidden');
			}

			this.refresh();
		},

		showAssign: function(baseActionKey, buttonContext, buttonMode, actionBossComponent, additionalData){
			var self = this;
			if(buttonContext === 'tags'){
				var mediaID = (additionalData || {}).mediaID;
				if(mediaID){
					return self.getCategorizedFiles(mediaID).then(function(media){
						var cmsEntitiesCategories = utils.simpleCopy((media.children || {}).cms_entities_categories || {});
						utils.media.file.prepare(media, store.get(self.requestID, self.sessionID, self.serviceDomain), false);
						self.openTagAssignment([mediaID], cmsEntitiesCategories, 'showTagAssignmentMediaEnhanced', media);
						return utils.promise.resolve();
					})
				}
			}

			return utils.promise.reject();
		},

		openTagAssignment: function(mediaIDs, cmsEntitiesCategories, overrideAction, file){
			var self = this;
			self.model.assignTagsToMedia = {
				mediaIDs: mediaIDs,
				cmsEntitiesCategories: cmsEntitiesCategories
			};

			if(!self.model.tagPickerButton){
				self.furthest('base_form_form', undefined, function(form){
					form.find('base_form_fields_tag-picker-button', function(tagPickerButton){
						if(tagPickerButton.model.fieldCode === '_internalMediaTags'){
							self.model.tagPickerButton = tagPickerButton
						}
					});
				});
			}

			if(self.model.tagPickerButton){
				self.model.tagPickerButton.open((cmsEntitiesCategories || {}).data || [], function(options){

					// submit file details and tag-assignments if necessary
					const decisionType = (options.decisionOptions || {}).decisionType || 'cancel'
					if(options.enhancementComponent && decisionType !== 'cancel' && decisionType !== 'close' && decisionType !== 'done'){
						self.onTagsPicked(options);
						options.enhancementComponent.submit();
					}
				}, overrideAction, file);
			}
		},

		onTagsPicked: function(options){
			var self = this;
			var dirtyAssignedTags, dat, media, mediaID, mediaIDs, mediaIndex;
			var tagsToUpdate = [];
			if(
				(dirtyAssignedTags = ((options || {}).decisionOptions || {}).dirtyAssignedTags || {})
				&&
				(media = self.model.assignTagsToMedia || {})
				&&
				(mediaIDs = media.mediaIDs)
			){
				for(mediaIndex in mediaIDs){
					for(dat in dirtyAssignedTags){
						tagsToUpdate.push({
							type: dirtyAssignedTags[dat].type === 'delete' ? 'delete' : undefined,
							attributes: {
								entityCategoryID: 	dirtyAssignedTags[dat].entityCategoryID || dirtyAssignedTags[dat].id,

								entityID: 			mediaIDs[mediaIndex],
								entityType: 		options.categoryEntityType,
								categoryID: 		dirtyAssignedTags[dat].categoryID,
								categoryDataID: 	dirtyAssignedTags[dat].categoryDataID,
								enabled: 			dirtyAssignedTags[dat].enabled
							}
						});
					}
				}
			}

			if(tagsToUpdate.length > 0){
				self.performAction(
					self.prepareAction('updateMediaTagAssignments', undefined, undefined, {
						source: {
							submit: {
								data: {
									data: tagsToUpdate
								}
							}
						}
					})
				).then(function(context){
					var statusController;
					if((statusController = getComponent('statusController'))) {
						statusController.addPanel('status.done.assigned');
					}
				})
			}
		},

		getCategorizedFiles: function(mediaID){
			var self = this;
			if(mediaID){
				return self.performAction(
					self.prepareAction('getCategorizedFiles', undefined, undefined, {
						source: {
							load: {
								resourceFilters: {
									listOfMediaIDs: [mediaID]
								}
							}
						}
					})
				).then(function(context){
					return utils.promise.resolve(((((context || {}).action || {}).response || {}).data || [])[0]);
				})
			}

			return utils.promise.reject();
		},

		onChange: function(value){
			var self = this;
			var promise;

			this.model.dataJSON = value;

			// tell parent form that something has been changed
			this.parent(function(parentComponent){
				promise = parentComponent.trigger('onChildChanged', {
					fieldCode:  self.model.fieldCode,
					value:      value
				});
			});

			if(!promise) promise = utils.promise.resolve();
			return promise;
		},

		onBeforeRender: function(){
			var self = this;
			var fileIndex;
			var realIndex = -1;
			// set index and correct index gaps if necessary
			self.model.indexGapFound = false;
			for(fileIndex of Object.keys(this.model.dataJSON || {})){
				if(this.model.dataJSON[fileIndex]){
					realIndex++;
					if(!self.model.dataJSON[fileIndex].index || self.model.dataJSON[fileIndex].index != realIndex) self.model.dataJSON[fileIndex].index = realIndex;
					if(realIndex != fileIndex){
						self.model.indexGapFound = true;
						self.model.dataJSON[realIndex] = self.model.dataJSON[fileIndex];
						delete self.model.dataJSON[fileIndex];
					}
				}
			}
		},

		prepare: function(storage){
			var user = (storage|| {}).user
			if(user) 	this.model.extendedButtonActionsGranted = user.hasAccessTo('usage:media:extendedButtonActions', this.scope)
			else 		this.model.extendedButtonActionsGranted = false;
		},

		prepareForSubmit: function(){
			var self = this;
			var prepareFilePromises = [];
			var fileDataChanged = !!self.model.indexGapFound || !!self.model.orderChanged;

			// correct index positions if necessary
			prepareFilePromises.push(this.refreshOrder());

			// check if config prevents some user decisions (like maxNrOfElements limit reached, ...)
			var managementConfig = {};
			if(this.model.config) managementConfig = this.model.config.managementConfig;
			self.reworkFileList(managementConfig, false);

			var deletionCounter = 0;
			var originalDataJSON = utils.simpleCopy(this.model.dataJSON);
			utils.forEach(this.model.dataJSON, function(file, index){
				index = parseInt(index);

				if(file.delete){
					delete self.model.dataJSON[index];
					deletionCounter++;
					fileDataChanged = true;
				}

				// do some index corrections
				if(self.model.dataJSON[index]){
					self.model.dataJSON[index] = utils.media.file.cleanupElementBeforeSet(self.model.dataJSON[index]);

					if(deletionCounter > 0){
						self.model.dataJSON[index-deletionCounter] = self.model.dataJSON[index];
						delete self.model.dataJSON[index];
					}
				}
			});

			return utils.promise.performAll(this, prepareFilePromises).then(function(){
				if(prepareFilePromises.length > 0){
					var result;
					if(fileDataChanged){
						self.parent(function(parentComponent){
							result = parentComponent.trigger('onChildChanged', {
								fieldCode:  self.model.fieldCode,
								value:      self.model.dataJSON || {}
							});
						});
					}
					else {
						self.model.dataJSON = utils.simpleCopy(originalDataJSON);
						result = utils.promise.resolve();
					}

					return result;
				}

				return {};
			});
		},

		reworkFileList: function(managementConfig, bossMediaIndex, refreshDOMClasses){
			managementConfig = managementConfig || {};
			var maxNrOfElements = Number.MAX_SAFE_INTEGER;
			var nrOfElements = utils.collectionSize(this.model.dataJSON);
			var mediaIndex;
			if(refreshDOMClasses === undefined) refreshDOMClasses = true;
			if(managementConfig.multiSelect === false || managementConfig.maxNrOfElements <= 1){
				maxNrOfElements = 1;
			}
			else if(managementConfig.maxNrOfElements > 1){
				maxNrOfElements = managementConfig.maxNrOfElements;
			}
			var nrOfElementsReadyForDeletion = 0;
			for(mediaIndex = 0; mediaIndex < nrOfElements; mediaIndex++){
				if(this.model.dataJSON[mediaIndex].delete){
					nrOfElementsReadyForDeletion++;
				}
			}
			var realMediaIndex = -1;
			for(mediaIndex = 0; mediaIndex < (nrOfElements - nrOfElementsReadyForDeletion - maxNrOfElements); mediaIndex++){
				do {
					realMediaIndex++;
					if(!this.model.dataJSON[realMediaIndex].delete && realMediaIndex != bossMediaIndex){
						this.model.dataJSON[realMediaIndex].delete = true;
						break;
					}
				} while(realMediaIndex < nrOfElements);
			}

			if(refreshDOMClasses) this.refreshDOMClasses();
		},

		refreshDOMClasses: function(){
			var mediaID, mediaIndex, file, $target;
			var stateClasses = 'delete';
			for(mediaIndex in this.model.dataJSON){
				file = this.model.dataJSON[mediaIndex];
				mediaID = file.mediaID;
				$target = this.$.find('[data-media-id="' + this.model.dataJSON[mediaIndex].mediaID + '"]').removeClass(stateClasses);
				if(file.delete) $target.addClass('delete');
			}
		},

		refreshDirtyStatus: function(){
			var mediaIndex, image;
			this.model.isDirty = false;
			for(mediaIndex in this.model.dataJSON){
				image = this.model.dataJSON[mediaIndex];
				if(image.delete) {
					this.model.isDirty = true;
					break;
				}
			}

			if(this.model.isDirty) 	this.$.addClass('isDirty');
			else 					this.$.removeClass('isDirty');
		},




		initDraggables: function($element){
			this.model.draggable = {};
			// this.model.draggable.performedOffsets = {};
			this.model.draggable.$container = $element.find('.media');
			this.model.draggable.$elements = this.model.draggable.$container.find('.base_form_media_file_file');
			this.model.draggable.container = {
				width:  this.model.draggable.$container.width(),
				height: this.model.draggable.$container.height()
			};
			this.model.draggable.elements = {
				width:  this.model.draggable.$elements.first().outerWidth(true),
				height: this.model.draggable.$elements.first().outerHeight(true)
			};
			this.model.draggable.dirtyElements      = {};
			this.model.draggable.dirtyElementsMove  = {};
			this.model.draggable.finalDirtyElements = {};
			this.model.draggable.resetElements      = {};
			this.model.draggable.indexMapping = {};
			this.model.draggable.nrOfElements       = this.model.draggable.$elements.length;
			this.model.draggable.nrOfElementsPerRow = parseInt(this.model.draggable.container.width / this.model.draggable.elements.width);
			this.model.draggable.nrOfRows           = this.model.draggable.nrOfElements / this.model.draggable.nrOfElementsPerRow;
			var nrOfRows;
			if((nrOfRows = parseInt(this.model.draggable.nrOfRows)) < this.model.draggable.nrOfRows){
				this.model.draggable.nrOfRows = ++nrOfRows;
			}

			this.model.draggable.initialized = true;
			this.model.draggable.started = false;

			Draggable.create(
				this.model.draggable.$elements,
				{
					bounds:             this.model.draggable.$container,
					cursor:             'pointer',
					minimumMovement:    6,
					onClick:            this.onClick,
					onClickParams:      [this],
					onDragStart:        this.onDragStart,
					onDragStartParams:  [this],
					onDrag:             this.onDrag,
					onDragParams:       [this],
					onDragEnd:          this.onDragEnd,
					onDragEndParams:    [this],
					onRelease:          this.onRelease,
					onReleaseParams:    [this]
				}
			);
		},

		onClick: function(component){
			$(this.target).css('z-index', 'initial');


			// var mediaID;
			// if((mediaID = this.target.dataset.mediaId)){
			//
			// 	var fileDetails;
			// 	utils.forEach(component.model.dataJSON, function(details, index){
			// 		if(details.mediaID == mediaID){
			// 			fileDetails = details;
			// 			return false;
			// 		}
			// 	});
			//
			// 	if(fileDetails){
			// 		component.performAction(
			// 			component.prepareAction('fileDetails', mediaID, {
			// 				fileDetails: fileDetails
			// 			})
			// 		);
			// 	}
			// }
		},

		onDragStart: function(component){
			if(component.model.draggable.initialized){
				component.model.draggable.started = true;
				var $target = $(this.target);
				$target.addClass('dragInCharge');
				var index = parseInt($target.attr('data-media-index'));
				var i = component.model.dataJSON[index].index;
				// var mediaID     = parseInt($target.attr('data-media-id'));
				// var performedOffset = { index: 0, rows: 0, cols: 0 };
				// if(mediaID){
				// 	if(component.model.draggable.performedOffsets[mediaID]){
				// 		performedOffset = component.model.draggable.performedOffsets[mediaID];
				// 	}
				// 	else {
				// 		component.model.draggable.performedOffsets[mediaID] = performedOffset;
				// 	}
				// }
				// if(component.model.draggable.dirtyElements[index] == undefined){
					component.model.draggable.dirtyElements[index]      = {};
				// }
				component.model.draggable.dirtyElementsMove[index]  = {};
				if(component.model.draggable.finalDirtyElements[index] == undefined){

					component.model.draggable.finalDirtyElements[index] = {};
				}
				component.model.draggable.resetElements[index]      = {};
				component.model.draggable.position = {
					// performedOffset:    performedOffset,
					// id:     mediaID,
					index:  index,
					row:    parseInt(index / component.model.draggable.nrOfElementsPerRow),
					col:    (index % component.model.draggable.nrOfElementsPerRow),
					i:      i,
					r:      parseInt(i / component.model.draggable.nrOfElementsPerRow),
					c:      (i % component.model.draggable.nrOfElementsPerRow)
				};

				// console.log('onDragStart', this, component.model.draggable);
			}
		},
		onDrag: function(component){
			if(component.model.draggable.initialized && component.model.draggable.started){
				// var originalOffset = {
				// 	rows: Math.round(this.y / component.model.draggable.elements.height),
				// 	cols: Math.round(this.x / component.model.draggable.elements.width)
				// };
				// originalOffset.index = (originalOffset.rows * component.model.draggable.nrOfElementsPerRow);
				// if(originalOffset.rows < 0) originalOffset.index -= originalOffset.cols;
				// else                        originalOffset.index += originalOffset.cols;

				// var offset = {
				// 	rows: originalOffset.rows + component.model.draggable.position.performedOffset.rows,
				// 	cols: originalOffset.cols + component.model.draggable.position.performedOffset.cols
				// };

				var pos             = component.model.draggable.position || {};
				var dirties         = component.model.draggable.dirtyElements[pos.index];
				var finalDirties    = component.model.draggable.finalDirtyElements[pos.index];
				var dirtyIndexes    = Object.keys(dirties);

				var offset = {
					r: this.y / component.model.draggable.elements.height,
					c: this.x / component.model.draggable.elements.width,
					rows: Math.round(this.y / component.model.draggable.elements.height),
					cols: Math.round(this.x / component.model.draggable.elements.width)
				};
				offset.index = (offset.rows * component.model.draggable.nrOfElementsPerRow);
				// if(offset.rows < 0) offset.index -= offset.cols;
				// else
					offset.index += offset.cols;

				// correct offset boundaries
				offset.index    = Math.max(-pos.index,          Math.min(offset.index,    component.model.draggable.nrOfElements - 1 - pos.index));
				offset.rows     = Math.max(1 - component.model.draggable.nrOfRows,              Math.min(offset.rows,     component.model.draggable.nrOfRows - 1));
				offset.cols     = Math.max(1 - component.model.draggable.nrOfElementsPerRow,    Math.min(offset.cols,     component.model.draggable.nrOfElementsPerRow - 1));
				if((pos.row + offset.rows) == (component.model.draggable.nrOfRows - 1)){
					offset.cols = Math.min(offset.cols, ((component.model.draggable.nrOfElements - 1) % component.model.draggable.nrOfElementsPerRow) - pos.col);
				}



				// animation necessary
				if(offset.rows != 0 || offset.cols != 0 || pos.i != pos.index || dirtyIndexes.length > 0){
					// if(component.model.draggable.onDragTimeout) clearTimeout(component.model.draggable.onDragTimeout);
					// component.model.draggable.onDragTimeout = setTimeout(function(){
					// 	// console.log('MOVE DETECTED', offset);
					// 	component._onDrag(offset);
					// }, 50);

					var start, end, row, col, i, r, c;
					var indexes = {
						left: {},
						leftDown: {},
						right: {},
						rightUp: {},
						reset: {}
					};
					var indexesRelative = {
						left: {},
						leftDown: {},
						right: {},
						rightUp: {},
						reset: {}
					};
					var indexesLength = {
						left: 0,
						leftDown: 0,
						right: 0,
						rightUp: 0,
						reset: 0
					};
					// var pos     = utils.copy(component.model.draggable.position);
					var lastCol = component.model.draggable.nrOfElementsPerRow - 1;
					// if(offset.index > 0){
					if((pos.index + offset.index) > pos.i){
						// start   = pos;
						start = {
							index: pos.i,
						};
						start.row = pos.r;
						start.col = pos.c;
						end     = {
							index:  pos.index + offset.index,
							row:    pos.row + offset.rows,
							col:    pos.col + offset.cols
						};
					}
					else {
						// end     = pos;
						end = {
							index: pos.i,
						};
						end.row = pos.r;
						end.col = pos.c;
						start   = {
							index:  pos.index + offset.index,
							row:    pos.row + offset.rows,
							col:    pos.col + offset.cols
						};
					}

					// console.log('##########', utils.copy(pos), utils.copy(offset), utils.copy(start), utils.copy(end));

					var index = start.index;
					var dirtyInCharge = false;
					var checkingDirties = false;
					var mappingIndex;
					var isRelative;

					// TODO: DEBUG
					// var minIndex = start.index;
					// var maxIndex = end.index;
					// index = 0;
					// start.row = 0;
					// start.col = 0;
					// end.row = component.model.draggable.nrOfRows - 1;
					// end.col = (component.model.draggable.nrOfElements % component.model.draggable.nrOfElementsPerRow) - 1;

					for(r = start.row; r <= (end.row + dirtyIndexes.length); r++){
					// for(r = start.row; r <= end.row; r++){
					// 	for(c = 0; c < component.model.draggable.nrOfElementsPerRow; c++) {
					// for(r = 0; r <= (component.model.draggble.nrOfRows - 1 + dirtyIndexes.length); r++){
						for(c = 0; c < component.model.draggable.nrOfElementsPerRow; c++) {
							// within range?
							if(r == start.row && c < start.col){
								continue;
							}
							else if(r == end.row && c > end.col){
								break;
							}
							// handle dirties of last onDrag call
							else if(r > end.row){
								checkingDirties = true;
								i = dirtyIndexes[(r - end.row - 1)];
								mappingIndex = dirties[i];
								dirtyInCharge = dirties[i] !== undefined;
								// if(index !== undefined && finalDirties[index] !== undefined){
								// 	i = finalDirties[index];
								// 	dirtyInCharge = true;
								// }
								// else {
								// 	i = -5555555555;
								// 	dirtyInCharge = false;
								// }
							}
							// set actual row and col
							else {
								// set index to actual elements index
								// i = component.model.dataJSON[index].index;
								if(component.model.draggable.indexMapping[index] !== undefined){
									mappingIndex = component.model.draggable.indexMapping[index];
								}
								else {
									mappingIndex = index;
								}
								i = (component.model.dataJSON[mappingIndex] || {}).index;
								row = r;
								col = c;
							}

							// isRelative = index != mappingIndex;

							if(index != pos.i){
							// if(index != pos.i && index >= minIndex && index <= maxIndex){
								if(dirtyInCharge){
									if(dirties[i] !== undefined){
										// reset
										indexes.reset[i] = mappingIndex;
										// indexesRelative.reset[i] = isRelative;
										indexesLength.reset++;
									}
								}
								else if(!checkingDirties){
									// reset dirty
									delete dirties[i];

									if(row < pos.row){
										if(col == lastCol){
											// left down
											indexes.leftDown[i] = mappingIndex;
											// indexesRelative.leftDown[i] = isRelative;
											indexesLength.leftDown++;
										}
										else {
											// right
											indexes.right[i] = mappingIndex;
											// indexesRelative.right[i] = isRelative;
											indexesLength.right++;
										}
									}
									else if(row > pos.row){
										if(col == 0){
											// right up
											indexes.rightUp[i] = mappingIndex;
											indexesRelative.rightUp[i] = isRelative;
											indexesLength.rightUp++;
										}
										else {
											// left
											indexes.left[i] = mappingIndex;
											// indexesRelative.left[i] = isRelative;
											indexesLength.left++;
										}
									}
									else {
										if(col < pos.col){
											// right
											indexes.right[i] = mappingIndex;
											// indexesRelative.right[i] = isRelative;
											indexesLength.right++;
										}
										else if(col > pos.col) {
											// left
											indexes.left[i] = mappingIndex;
											// indexesRelative.left[i] = isRelative;
											indexesLength.left++;
										}
										else {
											// force original position
											indexes.reset[i] = mappingIndex;
											// indexesRelative.reset[i] = isRelative;
											indexesLength.reset++;
											// console.log(' ###############################  RESET!!! ################################', mappingIndex, i);
										}
									}
								}
							}

							if(checkingDirties) break;
							index++;
						}
					}

					var properties, movement, move, selectors, selector, finalIndexOffset;
					component.model.draggable.dirtyElements[pos.index]      = {};
					// component.model.draggable.dirtyElementsMove[pos.index]  = {};
					// component.model.draggable.finalDirtyElements[pos.index] = {};
					// component.model.draggable.resetElements[pos.index]      = {};
					var debug = Object.keys(indexes);
					debug.push('######');
					for(move in indexes){
						debug.push(move);
						if(indexesLength[move] > 0){
							finalIndexOffset = 0;
							// movement = {
							// 	left: 0,
							// 	top: 0
							// };
							//
							if(move === 'left'){
								finalIndexOffset    = -1;
							// 	movement.left       = -1;
							// 	// movement.left     = -component.model.draggable.elements.width;
							}
							else if(move === 'right'){
								finalIndexOffset    = 1;
							// 	movement.left       = 1;
							// 	// properties.left     = component.model.draggable.elements.width;
							}
							else if(move === 'leftDown'){
								finalIndexOffset    = 1;
							// 	movement.left       = -(component.model.draggable.nrOfElementsPerRow - 1);
							// 	movement.top        = 1;
							// 	// properties.top      = component.model.draggable.elements.height;
							// 	// properties.left     = -((component.model.draggable.nrOfElementsPerRow - 1) * component.model.draggable.elements.width);
							}
							else if(move === 'rightUp'){
								finalIndexOffset    = -1;
							// 	movement.left       = (component.model.draggable.nrOfElementsPerRow - 1);
							// 	movement.top        = -1;
							// 	// properties.top      = -component.model.draggable.elements.height;
							// 	// properties.left     = ((component.model.draggable.nrOfElementsPerRow - 1) * component.model.draggable.elements.width);
							}


							// if(movement.left != 0 || movement.top != 0){
							if(move != 'reset'){
								for(i in indexes[move]){
								    i = parseInt(i);
									component.model.draggable.dirtyElements[pos.index][i]                       = indexes[move][i];
									component.model.draggable.dirtyElementsMove[pos.index][indexes[move][i]]    = finalIndexOffset;
									component.model.draggable.finalDirtyElements[pos.index][indexes[move][i]]   = (i + finalIndexOffset);
									// console.log(move, indexes[move][i], ' ==> (', i, ' + ', finalIndexOffset, ') === ', (i + finalIndexOffset));
									// delete component.model.draggable.resetElements[pos.index][i];
								}
							}
							else {
								var lastFinalIndexOffset;
								for(i in indexes[move]) {
									i = parseInt(i);
									// lastFinalIndexOffset = 0;
									if(component.model.draggable.dirtyElementsMove[pos.index][indexes[move][i]] !== undefined){
										component.model.draggable.dirtyElementsMove[pos.index][indexes[move][i]] *= -1;
										lastFinalIndexOffset = component.model.draggable.dirtyElementsMove[pos.index][indexes[move][i]];
										component.model.draggable.finalDirtyElements[pos.index][indexes[move][i]] = (i + lastFinalIndexOffset);
										// console.log(move, indexes[move][i], ' ==> (', i, ' + ', lastFinalIndexOffset, ') === ', (i + lastFinalIndexOffset));
									}
									else {
										component.model.dataJSON[indexes[move][i]].indexOffset = 0;
										// console.log('non dirty reset', move, indexes[move][i], ' ==> (', i, ' + ', 0, ') === ', (i + 0));
										component.model.draggable.finalDirtyElements[pos.index][indexes[move][i]] = (i + 0);
										// component.model.draggable.dirtyElements[pos.index][i]                       = indexes[move][i];
										// component.model.draggable.dirtyElementsMove[pos.index][indexes[move][i]]    = 0;
										// component.model.draggable.finalDirtyElements[pos.index][indexes[move][i]]   = i;
										// console.log(move, indexes[move][i], ' ==> (', i, ' + ', 0, ') === ', i);
									}
								}

								// utils.refReplace(component.model.draggable.resetElements[pos.index], indexes[move]);
							}

							// selectors = {
							// 	absolute: '',
							// 	relative: ''
							// };
							selectors = {};
							// TODO: check simple loops of objects
							var debug2 = Object.keys(indexes[move]);
							debug2.push('######');
							// var originalIndex;
							var indexOffset;
							for(i in indexes[move]){
								mappingIndex = indexes[move][i];
								// indexOffset = Math.abs((component.model.dataJSON[mappingIndex].indexOffset || 0) + component.model.draggable.dirtyElementsMove[pos.index][mappingIndex]);
								indexOffset = (component.model.dataJSON[mappingIndex].indexOffset || 0) + finalIndexOffset;

								debug2.push(indexes[move][i] + 'A');
								if(selectors[mappingIndex] == undefined) selectors[mappingIndex] = {};
								if(selectors[mappingIndex][indexOffset] == undefined) selectors[mappingIndex][indexOffset] = '';
								selectors[mappingIndex][indexOffset] += '[data-media-index="' + mappingIndex + '"],';
								// originalIndex =
								// debug2.push(i);
								// if(component.model.draggable.indexMapping[i] !== undefined){
								// 	mappingIndex = component.model.draggable.indexMapping[i];
								// }
								// else {
								// 	mappingIndex = indexes[move][i];
								// }

								// if(indexesRelative[move][i]){
								// 	debug2.push(indexes[move][i] + 'R');
								// 	selectors.relative += '[data-media-index="' + indexes[move][i] + '"],';
								// }
								// else {
								// 	debug2.push(indexes[move][i] + 'A');
								// 	selectors.absolute += '[data-media-index="' + indexes[move][i] + '"],';
								// }
							}
							// console.log('selector', debug2.join(','));

							var newRow, newCol;
							for(mappingIndex in selectors){
								for(indexOffset in selectors[mappingIndex]){
									selector = selectors[mappingIndex][indexOffset];
									if(selector != ''){
										mappingIndex = parseInt(mappingIndex);
										indexOffset = parseInt(indexOffset);
										index = mappingIndex + indexOffset;
										// i = component.model.dataJSON[mappingIndex].index;
										// i = mappingIndex + (component.model.dataJSON[mappingIndex].indexOffset || 0);
										i = mappingIndex;
										selector = selector.replace(/,$/, '');

										newRow = parseInt(index / component.model.draggable.nrOfElementsPerRow);
										// if((r = parseInt(newRow)) < newRow) newRow = r;
										// else                                newRow = r;
										newCol = (index % component.model.draggable.nrOfElementsPerRow);
										row = parseInt(i / component.model.draggable.nrOfElementsPerRow);
										// if((r = parseInt(row)) < row) row = r;
										col = (i % component.model.draggable.nrOfElementsPerRow);

										r = newRow - row;
										c = newCol - col;

										// if(type == 'absolute'){
											properties = {
												x:   (c * component.model.draggable.elements.width),
												y:    (r * component.model.draggable.elements.height)
											};
										// }
										// else if(type == 'relative'){
										// 	props = {};
										// 	if(properties.left != 0)    props.left  = (properties.left > 0 ? '+' : '-') + '=' + Math.abs(properties.left) + 'px';
										// 	if(properties.top != 0)     props.top   = (properties.top > 0 ? '+' : '-') + '=' + Math.abs(properties.top) + 'px';
										// }


										// console.log('PROPERTIES', mappingIndex, indexOffset, utils.copy(properties));

										component.model.draggable.$elements.filter(selector).each(function(){
											TweenMax.to(
												this,
												component.config.draggable.durations.moveElement,
												properties
											);
										});
										// TweenLite.to(
										// 	component.model.draggable.$elements.filter(selector),
										// 	component.config.draggable.durations.moveElement,
										// 	properties
										// 	// {
										// 	// 	left: -122
										// 	// }
										// );
									}
								}
							}
						}
					}
					// console.log('indexes', debug.join(','));
					// console.log.apply(this, arguments);
				}

				// console.log('onDrag', mediaIndex, this, component);
			}
		},
		onDragEnd: function(component){
			if(component.model.draggable.initialized && component.model.draggable.started){
				// console.log('onDragEnd', this, arguments);
				$(this.target).removeClass('dragInCharge');
				// component.refresh();
			}
		},
		onRelease: function(component){
			if(component.model.draggable.initialized && component.model.draggable.started){
				component.model.draggable.initialized = false;

				var pos = component.model.draggable.position || {};

				// calculate offset
				var offset = {
					rows: Math.round(this.y / component.model.draggable.elements.height),
					cols: Math.round(this.x / component.model.draggable.elements.width)
				};
				offset.index = (offset.rows * component.model.draggable.nrOfElementsPerRow);
				offset.index += offset.cols;

				// correct offset boundaries
				offset.index    = Math.max(-pos.index,          Math.min(offset.index,    component.model.draggable.nrOfElements - 1 - pos.index));
				offset.rows     = Math.max(1 - component.model.draggable.nrOfRows,              Math.min(offset.rows,     component.model.draggable.nrOfRows - 1));
				offset.cols     = Math.max(1 - component.model.draggable.nrOfElementsPerRow,    Math.min(offset.cols,     component.model.draggable.nrOfElementsPerRow - 1));
				if((pos.row + offset.rows) == (component.model.draggable.nrOfRows - 1)){
					offset.cols = Math.min(offset.cols, ((component.model.draggable.nrOfElements - 1) % component.model.draggable.nrOfElementsPerRow) - pos.col);
				}

				// update target position
				var $target = $(this.target);
				TweenMax.to(
					$target,
					component.config.draggable.durations.moveElement,
					{
						x:  (offset.cols * component.model.draggable.elements.width),
						y:  (offset.rows * component.model.draggable.elements.height),
						onComplete: function(){
							$target.css('z-index', 'initial');
							component.refresh();
						}
					}
				);

				// correct reset indexes if necessary
				var index, i;
				var dirtyMoves = component.model.draggable.dirtyElementsMove[pos.index];

				// update new dirties' indexes
				var targetIndex = pos.index + offset.index;
				var finalDirties = component.model.draggable.finalDirtyElements[pos.index];
				if(pos.i < targetIndex){
					for(index in finalDirties){
						i = parseInt(finalDirties[index]);
						if(i >= pos.i && i <= targetIndex){
							// component.model.dataJSON[index].index = parseInt(i);
							if(!component.model.dataJSON[index].indexOffset){
								component.model.dataJSON[index].indexOffset = 0;
							}

							if(dirtyMoves[index]){
								component.model.dataJSON[index].indexOffset += dirtyMoves[index];
							}

							component.model.dataJSON[index].index = parseInt(index) + component.model.dataJSON[index].indexOffset;
							component.model.draggable.indexMapping[component.model.dataJSON[index].index] = parseInt(index);
						}
					}
				}
				else if(pos.i > targetIndex){
					for(index in finalDirties){
						i = parseInt(finalDirties[index]);
						if(i >= targetIndex && i <= pos.i){
							component.model.dataJSON[index].index = parseInt(i);
							if(!component.model.dataJSON[index].indexOffset){
								component.model.dataJSON[index].indexOffset = 0;
							}

							if(dirtyMoves[index]){
								component.model.dataJSON[index].indexOffset += dirtyMoves[index];
							}

							component.model.dataJSON[index].index = parseInt(index) + component.model.dataJSON[index].indexOffset;
							component.model.draggable.indexMapping[component.model.dataJSON[index].index] = parseInt(index);
						}
					}
				}
				component.model.dataJSON[pos.index].index = targetIndex;
				component.model.dataJSON[pos.index].indexOffset = targetIndex - pos.index;
				component.model.draggable.indexMapping[targetIndex] = pos.index;


				component.refreshOrder();
				component.model.orderChanged = true;
				component.model.draggable.started = false;
			}
		},

		refreshOrder: function(forceChange){
			// correct index positions if necessary
			var dataJSON = {};
			var changedIndexFound = false;
			var self = this;
			utils.forEach(this.model.dataJSON, function(file, index){
				if(file.index === undefined){
					self.model.dataJSON[index].index = index;
					file.index = index;
				}
				changedIndexFound = changedIndexFound || index != file.index;
				file.indexOffset = 0;
				dataJSON[file.index] = file;
			});
			if(changedIndexFound || forceChange) return this.onChange(dataJSON);
			return utils.promise.resolve();
		},

		openFileManagement: function(filterMediaIDs){
			var self = this;
			var listOfMediaIDs;

			if(filterMediaIDs) {
				var mediaIDs = {};
				utils.forEach(self.model.dataJSON, function(media, index){
					mediaIDs[media.mediaID] = true;
				});
				listOfMediaIDs = Object.keys(mediaIDs);
			}

			var modalSubTitle = 'fileManagement.modalSubTitle.multiSelect';
			var managementConfig = (self.model.config || {}).managementConfig || {};
			if(managementConfig.multiSelect === false || managementConfig.maxNrOfElements <= 1){
				modalSubTitle = 'fileManagement.modalSubTitle.singleSelect';
			}

			self.performAndStoreAction(
				'fileManagement_inEffect',
				self.prepareAction(
					'fileManagement',
					undefined,
					{
						fileConfig: 	self.model.config || {},
						listOfMediaIDs: listOfMediaIDs
					},
					{
						source: {
							load: {
								componentData: {
									model: {
										subTitle: utils.i18next.__(modalSubTitle)
									}
								}
							}
						}
					}
				)
			);
		}
	},

	hooks: {
		attach: function($element, options){
			if(!((this.formMapping || {}).fieldConfig || {}).disabled){
				this.initDraggables($element);
			}

			if(!options.refresh && this.model.indexGapFound){
				this.onChange(this.model.dataJSON);
			}
		},

		onChildChanged: function($element, options){
			if(options.fieldCode == this.model.fieldCode){
				this.onChange(options.value);
			}
		},

		onDecision: function($element, options){
			// init
			var self = this;

			switch(options.decisionComponent.componentClass){
				case 'base_modal_modal':
				case 'templates_modal_modal':
					switch(options.decisionType){
						case 'submit':
							var modalContentComponent = options.decisionComponent.actions.loadContent.source.load.component;
							// get selected media from mediaManagement
							if(modalContentComponent.hasClass('templates_mediaManagement_file_file')){
								modalContentComponent.find('templates_mediaManagement_file_fileList', function(fileListComponent){
									var selectedMedia = fileListComponent.getSelectedMedia();

									if(selectedMedia){
										// set newly selected media
										if(!self.model.dataJSON) self.model.dataJSON = {};
										var mediaAdded = false;
										var mediaFound = false;
										var mediaRefreshed = false;
										var refreshNecessary = false;
										var mediaIndex;

										// mark newly added files for render process
										utils.forEach(selectedMedia, function(file, index){
											mediaFound = false;
											utils.forEach(self.model.dataJSON, function(chosenFile, chosenIndex){
												if(chosenFile.mediaID == file.mediaID){
													mediaFound = true;
													mediaIndex = chosenIndex;
													return false;
												}
											});

											if(mediaFound){
												if(self.model.dataJSON[mediaIndex].delete){
													mediaRefreshed = true;
													file.index = mediaIndex;
													file.delete = false;
													refreshNecessary = true;
													self.model.dataJSON[file.index] = file;
												}
											}
											else {
												mediaAdded = true;
												refreshNecessary = true;
												file.index = utils.collectionSize(self.model.dataJSON);
												self.model.dataJSON[file.index] = file;
											}
										});

										// delete elements if necessary according to managementConfig
										self.reworkFileList(fileListComponent.model.managementConfig || {}, undefined, true);

										// trigger
										if(mediaAdded){
											self.refreshOrder(true).then(function(){
												// close fileManagement
												options.decisionComponent.hide();

												self.refresh();
											});
										}
										else if(mediaRefreshed){
											self.onChange(self.model.dataJSON).then(function(){
												options.decisionComponent.hide();

												if(refreshNecessary) self.refresh();
											});
										}
										else {
											// close fileManagement
											options.decisionComponent.hide();
										}
									}
								});
							}
							break;

						default:
							// hide fileManagement-Modal
							options.decisionComponent.hide();
							break;
					}
					break;
			}
		}
	}
};
